Properties.store.getters = {
    isFavorite: (state) => (value) => {
        return state.favorites.indexOf(value.toString()) !== -1;
    },
};